'use strict';exports.__esModule = true;exports.deleteUser = exports.editUser = exports.closeAddNewStaffForm = exports.setCurrentPaginationStep = exports.openAddNewStaffForm = exports.addUser = exports.getMyStaff = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var openAddNewStaffForm = (0, _reduxAct.createAction)('/OPEN_ADD_NEW_STAFF_FORM');
var closeAddNewStaffForm = (0, _reduxAct.createAction)('/CLOSE_ADD_NEW_STAFF_FORM');

var getMyStaff = (0, _reduxAct.createAction)('/GET_MY_STAFF');
var getMyStaffSuccess = (0, _reduxAct.createAction)('/GET_MY_STAFF_SUCCESS');
var getMyStaffFail = (0, _reduxAct.createAction)('/GET_MY_STAFF_FAIL');

var addUser = (0, _reduxAct.createAction)('/ADD_USER');
var addUserSuccess = (0, _reduxAct.createAction)('/ADD_USER_SUCCESS');
var addUserFail = (0, _reduxAct.createAction)('/ADD_USER_FAIL');

var editUser = (0, _reduxAct.createAction)('/EDIT_USER');
var editUserSuccess = (0, _reduxAct.createAction)('/EDIT_USER_SUCCESS');
var editUserFail = (0, _reduxAct.createAction)('/EDIT_USER_FAIL');

var deleteUser = (0, _reduxAct.createAction)('/DELETE_USER');
var deleteUserSuccess = (0, _reduxAct.createAction)('/DELETE_USER_SUCCESS');
var deleteUserFail = (0, _reduxAct.createAction)('/DELETE_USER_FAIL');

var setCurrentPaginationStep = (0, _reduxAct.createAction)('/SET_CURRENT_PAGINATION_STEP');

var initialState = {
  addNewStaffFormOpen: false,
  loading: false,
  loaded: false,

  addUserLoading: false,
  addUserLoaded: false,

  editUserLoading: false,
  editUserLoaded: false,

  query: null,
  skip: null,
  data: [],
  meta: null,
  filter: {},
  error: null,
  totalUsersCount: 0,
  currentPaginationStep: 1 };


var fetchLoad = function fetchLoad(_ref) {var _ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params,token = _ref.token;return (
    _axios2.default.get('/users/staff', {
      params: params,
      headers: { access_token: token } }).

    then(getMyStaffSuccess, getMyStaffFail));};

var fetchAddUser = function fetchAddUser(_ref2) {var data = _ref2.data,token = _ref2.token;return (
    _axios2.default.post('/users/staff', data, {
      headers: { access_token: token } }).

    then(addUserSuccess, addUserFail));};

var fetchEditUser = function fetchEditUser(_ref3) {var data = _ref3.data,token = _ref3.token,id = _ref3.id;return (
    _axios2.default.patch('/users/staff/' + id, data, {
      headers: { access_token: token } }).

    then(editUserSuccess, editUserFail));};

var fetchDeleteUser = function fetchDeleteUser(_ref4) {var token = _ref4.token,id = _ref4.id;return (
    _axios2.default.delete('/users/staff/' + id, {
      headers: { access_token: token } }).

    then(deleteUserSuccess, deleteUserFail));};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    filter: action.params ? action.params : {} }),
  promise(fetchLoad, action));};

var handleAddUser = function handleAddUser(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    addUserLoading: true,
    addUserLoaded: false }),
  promise(fetchAddUser, action));};

var handleEditUser = function handleEditUser(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    editUserLoading: true,
    editUserLoaded: false }),
  promise(fetchEditUser, action));};

var handleDeleteUser = function handleDeleteUser(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false }),
  promise(fetchDeleteUser, action));};

var handleLoadMyStaffSuccess = function handleLoadMyStaffSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    totalUsersCount: meta.totalUsersCount,
    data: data,
    meta: meta });

};

var handleLoadMyStaffFail = function handleLoadMyStaffFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error load my staff');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    error: error });

};

var handleAddUserSuccess = function handleAddUserSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});

  return Object.assign({},
  state, {
    addUserLoading: false,
    addUserLoaded: true,
    totalUsersCount: meta.totalUsersCount,
    data: data,
    meta: meta });

};

var handleAddUserFail = function handleAddUserFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error add user to my staff');

  return Object.assign({},
  state, {
    addUserLoading: false,
    addUserLoaded: false,
    error: error });

};

var handleDeleteUserSuccess = function handleDeleteUserSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    totalUsersCount: meta.totalUsersCount,
    data: data,
    meta: meta });

};

var handleDeleteUserFail = function handleDeleteUserFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error delete user to my staff');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var handleEditUserSuccess = function handleEditUserSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});

  return Object.assign({},
  state, {
    editUserLoading: false,
    editUserLoaded: true,
    totalUsersCount: meta.totalUsersCount,
    data: data,
    meta: meta });

};

var handleEditUserFail = function handleEditUserFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error edit user');

  return Object.assign({},
  state, {
    editUserLoading: false,
    editUserLoaded: false,
    error: error });

};

var handleOpenAddNewStaffForm = function handleOpenAddNewStaffForm(state) {return Object.assign({},
  state, {
    addNewStaffFormOpen: true });};


var handleCloseAddNewStaffForm = function handleCloseAddNewStaffForm(state) {return Object.assign({},
  state, {
    addNewStaffFormOpen: false });};


var handleSetCurrentPaginationStep = function handleSetCurrentPaginationStep(state, action) {return Object.assign({},
  state, {
    currentPaginationStep: action });};


var myStaff = (0, _reduxAct.createReducer)(function (on) {
  on(openAddNewStaffForm, handleOpenAddNewStaffForm);
  on(closeAddNewStaffForm, handleCloseAddNewStaffForm);

  on(getMyStaff, handleLoad);
  on(getMyStaffSuccess, handleLoadMyStaffSuccess);
  on(getMyStaffFail, handleLoadMyStaffFail);

  on(addUser, handleAddUser);
  on(addUserSuccess, handleAddUserSuccess);
  on(addUserFail, handleAddUserFail);

  on(editUser, handleEditUser);
  on(editUserSuccess, handleEditUserSuccess);
  on(editUserFail, handleEditUserFail);

  on(deleteUser, handleDeleteUser);
  on(deleteUserSuccess, handleDeleteUserSuccess);
  on(deleteUserFail, handleDeleteUserFail);

  on(setCurrentPaginationStep, handleSetCurrentPaginationStep);
}, initialState);exports.


getMyStaff = getMyStaff;exports.
addUser = addUser;exports.
openAddNewStaffForm = openAddNewStaffForm;exports.
setCurrentPaginationStep = setCurrentPaginationStep;exports.
closeAddNewStaffForm = closeAddNewStaffForm;exports.
editUser = editUser;exports.
deleteUser = deleteUser;exports.default =


myStaff;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/myStaff.js
// module id = 1261
// module chunks = 0